import Router from 'vue-router';
import {ROUTENAMES} from '@/consts/const.enum';

import OrderLayout from '@/views/OrderLayout.vue';
import { useOrderViewStore } from '@/store/pinia/orderview.store';
import type {Component} from 'vue';
import {useSideDrawerStore} from '@/store/pinia/sidedrawer.store';
import Vue from 'vue';

export const setupCheckout = (router: Router) => {
  setupRoutes(router);
};

const setupRoutes = (router: Router) => {
  if (router) {
    router.addRoute({
      name: ROUTENAMES.CHECKOUT,
      path: '/',
      component: OrderLayout,
      children: [
        {
          path: '',
          name: ROUTENAMES.CART,
          component: () => import('./views/CartView.vue'),
        },
        {
          name: ROUTENAMES.EMPTY_CART,
          path: ROUTENAMES.EMPTY_CART,
          component: () => import('./views/EmptyCart.vue'),
        },
      ],
    });
  }
};

export function registerCartItemSettingsInDrawer() {
  const sideDrawerStore = useSideDrawerStore();
  Vue.component('CartItemsSettingsInDrawer', () => import('./components/cart/CartItemSettingsInDrawer.vue'));
  sideDrawerStore.addSidebarItem({
    name: 'cart-items-settings-in-drawer',
  });
}


export const setupRecapitulationCartItems = () => {
  const { addRecapitulationDetail } = useOrderViewStore();
  addRecapitulationDetail({
    component: () => import('./components/cart/CartItems.vue') as Component,
    props: {
      'read-only-mobile': true,
    }
  });
};
